import {
    convertUniversalDateTimeToPersianDateTime,
    DialogSize,
    RaikoBaseDialogContentContainer,
    RaikoCreatorInfo,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    showServerErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import "./AddNewProductImage.scss"
import thumbnail from "../../../assets/images/uploadImage.svg"
import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {ProductImagesService} from "../../../serverService/productImagesService/ProductImagesService";
import {ProductVariantService} from "../../../serverService/productVariantService/ProductVariantService";
import FileManagerSelector from "../../fileManager2/selector/FileManagerSelector";
import {FileManagerTypes} from "../../../component/fileManager/FileManager";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function AddNewProductImage({
                                               productId,
                                               selectedItemId,
                                               handleCloseSelectImageDialog,
                                               handleAddNewProductImage
                                           }) {


    const [selectedImageUrl, setSelectedImageUrl] = useState("");
    const [galleryDialogOpenState, setGalleryDialogOpenState] = useState(false);
    const [selectedImageId, setSelectedImageId] = useState(-1);
    const [priority, setPriority] = useState(0);
    const [altText, setAltText] = useState("");
    const [variantList, setVariantList] = useState([]);
    const [variantId, setVariantId] = useState(-1);
    const [actionButtonLoading, setActionButtonLoading] = useState(false);
    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("")
    const service = new ProductImagesService();
    const productVariantService = new ProductVariantService();
    const loading = new LoadingHelper(useLoadingDispatcher())

    function handleSelectImage(id, url) {
        setSelectedImageId(id)
        setSelectedImageUrl(url)
    }

    useEffect(() => {
        if (typeof selectedItemId !== 'undefined' && selectedItemId >= 0) {
            getProductImageDetailsFromServer()
        }
    }, [selectedItemId]);

    useEffect(() => {
        getAllProductVariantSelectionFromServer()
    }, []);

    function getAllProductVariantSelectionFromServer() {
        productVariantService.getAllProductVariantSelection(productId)
            .then(response => {
                setVariantList([])
                response.map((item, index) => {
                    setVariantList(prevState => [
                        ...prevState,
                        raikoCustomSelectItemGenerator(item.id, item.title)
                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {

        })

    }

    function handleOpenFileManager() {
        setGalleryDialogOpenState(true)
    }

    function handleCreateNewProductImage() {
        if (selectedImageId >= 0) {
            setActionButtonLoading(true)
            service.addNewProductImage(productId, selectedImageId, variantId, altText, priority)
                .then(response => {
                    handleCloseSelectImageDialog()
                    handleAddNewProductImage(response)
                    showSuccessMessage("تصویر جدید با موفقیت افزوده شد.")
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(_ => {
                setActionButtonLoading(false)
            })
        } else
            showWarningMessage("لطفا تصویر مورد نظر خود را انتخاب نمایید.")
    }

    function getProductImageDetailsFromServer() {
        loading.show()
        service.getProductImageDetails(selectedItemId)
            .then(response => {
                setSelectedImageUrl(response.file.url)
                setVariantId(response.variant.id)
                setAltText(response.altText)
                setPriority(response.position)
                setCreatedBy(response.createdBy)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateProductImageDetails() {
        setActionButtonLoading(true)
        service.updateProductImageDetails(selectedImageId, variantId, priority, altText)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                handleCloseSelectImageDialog()
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setActionButtonLoading(false)
        })
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={_ => {
                    setGalleryDialogOpenState(false)
                }}
                open={galleryDialogOpenState}
                dialogSize={DialogSize.LARGE}
                pageTitle={"تصویر مورد نظر خود را انتخاب نمایید."}
            >
                <FileManagerSelector
                    setOpenDialog={setGalleryDialogOpenState}
                    bucketId={FileManagerTypes.POST_IMAGES.id}
                    setSelectedFileUrl={handleSelectImage}
                />
            </RaikoDefaultDialogPage>
            <RaikoBaseDialogContentContainer>
                <RaikoSectionContainer
                    title={selectedItemId < 0 ? "افزودن تصویر جدید" : "بروزرسانی تصویر"}
                    hasActionButton
                    actionButtonTitle={selectedItemId < 0 ? "افزودن" : "بروزرسانی"}
                    actionButtonLoadingState={actionButtonLoading}
                    actionButtonOnclick={selectedItemId < 0 ? handleCreateNewProductImage : handleUpdateProductImageDetails}
                    hasSecondaryButton
                    secondaryButtonTitle={"بازگشت"}
                    secondaryButtonOnClick={handleCloseSelectImageDialog}
                >
                    <RaikoGridOneColumn className={css`gap: 1rem`}>
                        <div
                            className={"baseSelectImageContainer"}
                            onClick={handleOpenFileManager}
                        >

                            {
                                selectedImageUrl && selectedImageUrl.length > 0 ?
                                    <img src={selectedImageUrl} alt=""/> :
                                    <img src={thumbnail} alt=""/>

                            }
                            <span>
                                {
                                    selectedImageId && selectedImageId >= 0 ?
                                        "برای تغییر تصویر کلیک نمایید." :
                                        "برای انتخاب تصویر کلیک نمایید."
                                }
                            </span>
                        </div>
                        <RaikoCustomSelect
                            labelText={"نوع محصول"}
                            value={variantId}
                            setValue={setVariantId}
                            items={variantList}
                        />
                        <RaikoSimpleInputOutlined
                            labelText={"متن جایگزین تصویر"}
                            value={altText}
                            setValue={setAltText}
                        />
                        <RaikoNumberInputOutlined
                            labelText={"اولویت"}
                            value={priority}
                            setValue={setPriority}
                            required
                        />
                    </RaikoGridOneColumn>
                    {selectedItemId >= 0 && <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>}

                </RaikoSectionContainer>

            </RaikoBaseDialogContentContainer>
        </>
    )
}